import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import _ from 'lodash';
import Has from '../../component/Permission/Has';
import './Users.css'
import UserInformation from '../../component/User/UserInformation';
import UserRoleInformation from '../../component/User/UserRoleInformation';
import LoadingSpinner from '../../component/LoadingSpinner/LoadingSpinner';
import { FF_USERS_PAGE } from '../../config/FeatureFlagTypes';
import { U_USER_ADMIN } from '../../config/PermissionTypes';
import { saveUser } from '../../service/UserService';
import { getCompanyRoles } from '../../service/CompanyService';
import { useCompany, useCompanyPermission } from '../../component/CompanySelection/CompanyContext';
import { getUrl } from '../../util/EfupUtility';
import { Alert } from '../../component/Alert/Alert';

export default function AddUser(props) {
    const [user, setUser] = useState({
        username: "",
        name: "",
        customerId: "",
        email: "",
        isActive: true,
        companyRole: {
            roleUuid: ""
        }
    });
    const [availableRoles, setAvailableRoles] = useState(null);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [savePending, setSavePending] = useState(false);
    const [banner, setBanner] = useState({
        show: false,
        type: "success",
        message: ""
    });
    const { companyNumber } = useCompany();
    const navigate = useNavigate();

    useEffect(() => {
        const roleDataHandler = (companyRoles) => {
            if (companyRoles) {
                setAvailableRoles(companyRoles);
            } else {
                showBanner("error", `An error occurred while retrieving company roles`)
            }
            setIsLoading(false);
        };

        getCompanyRoles(companyNumber, roleDataHandler);
    }, [companyNumber])

    //if permissions are not loaded, show loading spinner
    const companyPermission = useCompanyPermission();
    if (!companyPermission) {
        return (
            <div id="dashboard-loader">
                <LoadingSpinner blue />
            </div>
        );
    }

    const isSaveDisabled = () => {
        const errorsExist = !_.isEmpty(errors);
        return !user.name || !user.username || !user.customerId || !user.companyRole.roleUuid || errorsExist || savePending;
    }

    function handleUserUpdate(field, value) {
        let updatedUser = {...user};
        updatedUser[field] = value
        setUser(updatedUser);
    }

    const handleSaveUser = async () => {
        setSavePending(true);
        await Promise.resolve(saveUser(user, companyNumber))
            .then(() => {
                navigate(getUrl(companyNumber, '/users'))
            })
            .catch(error => {
                let message = error.response?.data || "An error occurred while trying to save the new user.";
                showBanner("error", message);
                setSavePending(false);
            });
    }

    const showBanner = (type, message) => {
        setBanner({
            show: true,
            type: type,
            message: message
        })
    }  


    return (
        <><Has isPageLevel={true} featureFlag={FF_USERS_PAGE} permission={U_USER_ADMIN}>
            {/* <!-- Page content--> */}
            <div className="container-fluid add-users-page" data-testid="add-users-page">
                <div className="cb-row page-title-area">
                    <div className="cb-col-xs-8 cb-col-lg-8 page-title">
                        <h1 data-testid="add-user-page-header-title">Add User</h1>
                    </div>
                </div>
                {isLoading ?
                <LoadingSpinner blue testId="add-users-loading-spinner" />
                : <>{banner.show && 
                    <Alert type={`${banner.type}`} handleOnClose={() =>  setBanner({ show: false, message: ""})} dataTestId='edit-user-notification'>
                        <div style={{ fontWeight: '500' }}>{banner.message}</div>
                    </Alert>}
                <div className="user-info-container" data-testid="user-info-fields">
                    <div className="sectionTitle">New User Information</div>
                    <UserInformation 
                        name={user.name}
                        userId={user.username}
                        email={user.email}
                        customerId={user.customerId}
                        errors={errors}
                        setErrors={setErrors}
                        handleFieldUpdate={handleUserUpdate}
                    />
                </div>
                <div className="role-container" data-testid="user-role-options">
                    <UserRoleInformation 
                        existingRoleUuid={user.companyRole.roleUuid}
                        availableRoles={availableRoles}
                        errors={errors}
                        setErrors={setErrors}
                        handleFieldUpdate={handleUserUpdate}
                    />
                </div>
                <div className="user-buttons" data-testid="add-user-buttons">
                    <Link to={getUrl(companyNumber, `/users/`)}>
                        <button
                            type="button"
                            className="cb-btn cb-btn-outline-secondary"
                            data-testid="add-user-cancel"
                            disabled={false}
                            onClick={() => null}>
                            Cancel
                        </button>
                    </Link>
                    <button 
                        className="cb-btn cb-btn-primary" 
                        data-testid="add-user-submit" 
                        disabled={isSaveDisabled()}
                        onClick={() => handleSaveUser()}>
                        Add User
                    </button>
                </div></>}
            </div>
        </Has></>
    );
}